/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AlertType,
    AlertTypeFromJSON,
    AlertTypeFromJSONTyped,
    AlertTypeToJSON,
    DocumentInfo,
    DocumentInfoFromJSON,
    DocumentInfoFromJSONTyped,
    DocumentInfoToJSON,
    DocumentStatus,
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    Interrogatory,
    InterrogatoryFromJSON,
    InterrogatoryFromJSONTyped,
    InterrogatoryToJSON,
    Source,
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentDetail
 */
export interface DocumentDetail {
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    name?: string | null;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof DocumentDetail
     */
    status?: DocumentStatus;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    location?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetail
     */
    uploadDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDetail
     */
    isArchived?: boolean;
    /**
     * 
     * @type {DocumentInfo}
     * @memberof DocumentDetail
     */
    info?: DocumentInfo;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetail
     */
    lastWordDownloadDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetail
     */
    fileSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    caseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetail
     */
    uploadedBy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDetail
     */
    caseIdConfirmed?: boolean;
    /**
     * 
     * @type {AlertType}
     * @memberof DocumentDetail
     */
    alert?: AlertType;
    /**
     * 
     * @type {Source}
     * @memberof DocumentDetail
     */
    source?: Source;
    /**
     * 
     * @type {Array<Interrogatory>}
     * @memberof DocumentDetail
     */
    interrogatories: Array<Interrogatory>;
}

export function DocumentDetailFromJSON(json: any): DocumentDetail {
    return DocumentDetailFromJSONTyped(json, false);
}

export function DocumentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'status': !exists(json, 'status') ? undefined : DocumentStatusFromJSON(json['status']),
        'location': !exists(json, 'location') ? undefined : json['location'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (new Date(json['uploadDate'])),
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'info': !exists(json, 'info') ? undefined : DocumentInfoFromJSON(json['info']),
        'lastWordDownloadDate': !exists(json, 'lastWordDownloadDate') ? undefined : (json['lastWordDownloadDate'] === null ? null : new Date(json['lastWordDownloadDate'])),
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'uploadedBy': !exists(json, 'uploadedBy') ? undefined : json['uploadedBy'],
        'caseIdConfirmed': !exists(json, 'caseIdConfirmed') ? undefined : json['caseIdConfirmed'],
        'alert': !exists(json, 'alert') ? undefined : AlertTypeFromJSON(json['alert']),
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'interrogatories': ((json['interrogatories'] as Array<any>).map(InterrogatoryFromJSON)),
    };
}

export function DocumentDetailToJSON(value?: DocumentDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'name': value.name,
        'status': DocumentStatusToJSON(value.status),
        'location': value.location,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate.toISOString()),
        'isArchived': value.isArchived,
        'info': DocumentInfoToJSON(value.info),
        'lastWordDownloadDate': value.lastWordDownloadDate === undefined ? undefined : (value.lastWordDownloadDate === null ? null : value.lastWordDownloadDate.toISOString()),
        'fileSize': value.fileSize,
        'caseId': value.caseId,
        'clientId': value.clientId,
        'uploadedBy': value.uploadedBy,
        'caseIdConfirmed': value.caseIdConfirmed,
        'alert': AlertTypeToJSON(value.alert),
        'source': SourceToJSON(value.source),
        'interrogatories': ((value.interrogatories as Array<any>).map(InterrogatoryToJSON)),
    };
}


